import axios from 'axios';

export const fetchPortalBuilderTemplates = async (
  token,
  deleteStatus,
  templateStatus
) => {
  try {
    const payload = { deleted_at: deleteStatus || null };
    if (templateStatus) payload.template_status = templateStatus;
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/portalbuilder/list`,
      payload,
      {
        headers: { Authorization: `${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching portal builder templates:', error);
    return [];
  }
};

export const fetchWorkFlowList = async (token) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/workflows/list`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error('Error fetching workflows:', error);
  }
};

export const deletePortalTemplate = async (templateId, token) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/portalbuilder/delete/${templateId}`,
      {
        headers: { Authorization: `${token}` },
      }
    );
    return true;
  } catch (error) {
    console.error('Error deleting template:', error);
    return false;
  }
};
